import React, {Component, type Node} from 'react';
import classNames from 'classnames';

import type {EventHandlerType, ChildrenType} from 'constants/flow/flowTypes';

import s from './checkbox.scss';

let lastId = 0;

type PropsType = {
    handleChange: EventHandlerType,
    inline?: boolean,
    checked: boolean,
    value: string | number | boolean,
    name?: string,
    children?: ChildrenType,
    fontSize?: string,
    lineHeight?: string,
};

/**
 *  Checkbox component
 */
export default class Checkbox extends Component<PropsType> {
    static defaultProps = {
        inline: false,
        fontSize: '1.6rem',
        lineHeight: '1.6rem',
        children: '',
        name: '',
    };

    /**
     * @param {Props} props Props passed during object creation
     */
    constructor(props: PropsType) {
        super(props);
        this.state = {
            id: lastId += 1,
        };
    }

    state: {id: number};

    /**
     * Render jsx to html
     * @returns {Node} Rendered react component
     */
    render(): Node {
        const {
            handleChange,
            inline,
            children,
            name,
            value,
            checked,
            fontSize,
            lineHeight,
        } = this.props;
        const {id} = this.state;

        return (
            <div className={classNames(s.wrap, {[s.inline]: inline})}>
                <input
                    type="checkbox"
                    id={`checkbox-button-${id}`}
                    onChange={handleChange}
                    name={name}
                    value={value}
                    checked={checked}
                />
                <label
                    htmlFor={`checkbox-button-${id}`}
                    data-value={value}
                    style={{fontSize, lineHeight}}
                >
                    {children}
                </label>
                <span className={s.check} />
            </div>
        );
    }
}
